var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Switch } from "react-vcomponents";
import { BaseComponentPlus } from "react-vextensions";
import { GetUsers, MeID } from "../Store/firebase/users";
import { SubNavBar, SubNavBarButton } from "./@Shared/SubNavBar";
import { AdminUI } from "./More/Admin";
import { LinksUI } from "./More/Links";
import { HasAdminPermissions } from "Store/firebase/userExtras";
import { Observer } from "vwebapp-framework";
import { store } from "Store";
let MoreUI = class MoreUI extends BaseComponentPlus({}, {}) {
    render() {
        const admin = HasAdminPermissions(MeID());
        const userCount = (GetUsers() || []).length;
        const currentSubpage = store.main.more.subpage;
        const page = "more";
        return (React.createElement(React.Fragment, null,
            React.createElement(SubNavBar, null,
                React.createElement(SubNavBarButton, { page: page, subpage: "links", text: "Links" }),
                admin && React.createElement(SubNavBarButton, { page: page, subpage: "admin", text: "Admin" })),
            React.createElement(Switch, null,
                React.createElement(LinksUI, null),
                currentSubpage == "admin" && React.createElement(AdminUI, null))));
    }
};
MoreUI = __decorate([
    Observer
], MoreUI);
export { MoreUI };
